<template>
  <div>
    <div class="v3kiosk-active-pass">
      <CRow v-if="activePass" class="justify-content-center">
        <hr class="kiosk-horizontal-line mb-2" />
        <div class="v3kiosk-active-pass-title mb-2">
          <!-- When pass status is queue -->
          <template v-if="isCurrentStatusQueue">
            <div class="text-center">
              {{ $t("kiosk.your_pass_request_is_in_the_queue") }}
            </div>
          </template>

          <!-- When pass status is not queue -->
          <template v-else>
            <div v-if="activePass.approved_by">
              {{ $t("kiosk.your_pass_is_approved") }}
            </div>
            <div v-else>
              {{ activePass?.created_by_user?.first_name || "" }}
              {{ activePass?.created_by_user?.last_name || "" }},
              {{ $t("kiosk.your_pass_is_created_and_awaiting_approval") }}
            </div>
          </template>
        </div>

        <!-- When pass status is queue -->
        <template v-if="isCurrentStatusQueue">
          <StatusBox
            class="d-flex justify-content-center mb-2"
            :title="queuePassTitle"
            title-color="#ffffff"
            background-color="#308DEB"
            icon="ri-loader-fill"
            icon-color="#ffffff"
          />
        </template>

        <!-- When pass status is not queue -->
        <template v-else>
          <StatusBox
            v-if="activePass.approved_by"
            class="d-flex justify-content-center mb-2"
            :title="$t('kiosk.active')"
            title-color="#ffffff"
            background-color="#008566"
            icon="ri-checkbox-circle-line"
            icon-color="#ffffff"
          />
          <StatusBox
            v-if="!activePass.approved_by"
            class="d-flex justify-content-center mb-2"
            :title="$t('kiosk.waiting_approval')"
            title-color="#ffffff"
            background-color="#308DEB"
            icon="ri-loader-fill"
            icon-color="#ffffff"
          ></StatusBox>
        </template>

        <div v-if="!isCurrentStatusQueue">
          {{
            activePass?.flags?.auto_pass?.is_valid ? $t("kiosk.auto_pass") : ""
          }}
        </div>

        <CCol class="v3kiosk-active-pass-table mb-2">
          <CRow class="v3kiosk-active-pass-table-header mb-1">
            <CCol class="v3kiosk-active-pass-table-header-info text-start ms-1">
              <div class="created-at">
                {{
                  dateTimeUtils.universalTimeZoneFormatter({
                    dateTime: isPassApproved
                      ? activePass?.approved_at || activePass?.created_at
                      : activePass?.created_at,
                    inputTimezone: timeInputZone,
                    inputFormat: timeInputFormat,
                    outputFormat: "dddd, DD, MMMM, YYYY"
                  })
                }}
              </div>
              <div class="time">
                {{ $t("kiosk.time") }}
                {{
                  dateTimeUtils.universalTimeZoneFormatter({
                    dateTime: isPassApproved
                      ? activePass?.approved_at || activePass?.created_at
                      : activePass?.created_at,
                    inputTimezone: timeInputZone,
                    inputFormat: timeInputFormat,
                    outputFormat: "h:mm a"
                  })
                }}
              </div>
            </CCol>
            <CCol
              class="v3kiosk-active-pass-table-header-pass-history align-self-center text-end me-1"
              @click="showPassHistory(passHistories)"
            >
              {{ passHistories.length }} <i class="ri-door-open-line" />
            </CCol>
          </CRow>
          <CRow class="v3kiosk-active-pass-table-content">
            <CCol class="v3kiosk-active-pass-table-content-text">
              {{ activePass.from ? activePass.from.name : "" }}
            </CCol>
            <CCol class="v3kiosk-active-pass-table-content-icon">
              <i class="ri-arrow-go-back-line" />
            </CCol>
            <CCol class="v3kiosk-active-pass-table-content-text">
              {{ activePass.to ? activePass.to.name : "" }}
            </CCol>
          </CRow>
          <CRow class="v3kiosk-active-pass-table-bottom mt-1">
            <CCol
              class="v3kiosk-active-pass-table-bottom-type d-flex flex-column justify-content-center align-content-center ms-1"
            >
              <div class="v3kiosk-active-pass-table-bottom-type-box">
                <div class="icon align-self-center">
                  <i class="ri-device-line" />
                </div>
                <div class="text">{{ $t("kiosk.ksk") }}</div>
              </div>
            </CCol>
            <!-- This will be used in future -->
            <!-- <CCol
              class="v3kiosk-active-pass-table-bottom-comments text-end align-self-center me-1"
            >
              <div>
                <span class="comment-count me-1">0</span>
                <i class="ri-chat-new-line" />
              </div>
            </CCol> -->
          </CRow>
        </CCol>

        <!-- When pass status is not queue -->
        <template v-if="!isCurrentStatusQueue">
          <CRow
            v-if="
              (!activePass?.approved_by && !isAutoPass) ||
              (activePass?.approved_by == null &&
                activePass?.flags?.auto_pass?.is_valid == false) ||
              (!activePass?.approved_by &&
                activePass?.flags?.auto_pass &&
                activePass?.flags?.auto_pass?.mode == 'stop_only')
            "
            class="v3kiosk-active-pass-staff-box my-2"
          >
            <div class="v3kiosk-active-pass-staff-box-text">
              {{ $t("kiosk.staff_use_only") }}
            </div>
          </CRow>

          <div
            v-if="
              (!activePass?.approved_by && !isAutoPass) ||
              (activePass?.approved_by == null &&
                activePass?.flags?.auto_pass?.is_valid == false) ||
              (!activePass?.approved_by &&
                activePass?.flags?.auto_pass &&
                activePass?.flags?.auto_pass?.mode == 'stop_only')
            "
            class="mt-2 mb-2"
          >
            <Label>{{ $t("kiosk.enter_your_pin") }}</Label>
            <InputField
              class="w-100"
              v-model="state.teacherPin"
              :invalid-feedback="errors.teacherPin ? $t(errors.teacherPin) : ''"
              :v-no-auto-fill-input="true"
              :autocomplete="false"
              input-type="password"
              @update:model-value="state.responseMessageTeacherApproval = null"
            >
            </InputField>

            <InfoBox
              v-if="
                state.reqResponse &&
                state.reqResponse.message &&
                state.reqResponse.message !=
                  'Submission failed, please try again.'
              "
              class="border-0 v3-info-box danger w-100 my-3"
              ><div
                class="v3-info-box-title v3-info-box-title-not-bold m-0 not-bold"
              >
                {{ state.reqResponse.message }}
              </div></InfoBox
            >

            <InfoBox
              v-if="
                state.reqResponse &&
                state.reqResponse.errors &&
                state.reqResponse.errors.teacher_pin
              "
              class="border-0 v3-info-box danger w-100 my-3"
              ><div
                class="v3-info-box-title v3-info-box-title-not-bold m-0 not-bold"
              >
                {{ state.reqResponse.errors.teacher_pin[0] }}
              </div></InfoBox
            >
            <CRow class="d-flex justify-content-center mt-3">
              <CCol v-if="!activePass?.approved_at">
                <BaseButton
                  class="w-100 d-flex align-items-center justify-content-center"
                  rounded
                  @click="cancelPass()"
                >
                  {{ $t("kiosk.cancel") }}
                </BaseButton>
              </CCol>
              <CCol>
                <BaseButton
                  class="w-100 d-flex align-items-center justify-content-center"
                  solid-gray
                  rounded
                  @click="cancel()"
                >
                  {{ $t("kiosk.close") }}({{ timeoutCounter }})
                </BaseButton>
              </CCol>
              <CCol v-if="currentStatus == 'waiting' && !activePass?.parent">
                <BaseButton
                  class="w-100 d-flex align-items-center justify-content-center"
                  rounded
                  solid-gradient
                  @click="updatePassStuff(state.actions.approved)"
                >
                  {{ $t("kiosk.approve") }}
                </BaseButton>
              </CCol>
            </CRow>
          </div>
          <div v-else>
            <CRow class="d-flex justify-content-center mt-3">
              <CCol v-if="!activePass?.approved_at">
                <BaseButton
                  class="w-100 d-flex align-items-center justify-content-center"
                  rounded
                  @click="cancelPass()"
                >
                  {{ $t("kiosk.cancel") }}
                </BaseButton>
              </CCol>
              <CCol>
                <BaseButton
                  class="w-100 d-flex align-items-center justify-content-center"
                  rounded
                  solid-gray
                  @click="cancel()"
                >
                  {{ $t("kiosk.close") }}({{ timeoutCounter }})
                </BaseButton>
              </CCol>
              <CCol v-if="isAutoPass && !activePass?.approved_at">
                <BaseButton
                  class="w-100 d-flex align-items-center justify-content-center"
                  rounded
                  solid
                  custom-color="#00b973"
                  @click="autoApprovePass()"
                >
                  {{ $t("kiosk.start") }}
                </BaseButton>
              </CCol>
            </CRow>
          </div>
        </template>

        <!-- When pass status is queue -->
        <template v-else>
          <CRow class="d-flex justify-content-center mt-3">
            <CCol>
              <BaseButton
                class="w-100 d-flex align-items-center justify-content-center"
                rounded
                solid
                @click="cancel()"
              >
                {{ $t("kiosk.close") }}({{ timeoutCounter }})
              </BaseButton>
            </CCol>
            <CCol>
              <BaseButton
                class="w-100 d-flex align-items-center justify-content-center"
                rounded
                @click="cancelPass()"
              >
                {{ $t("kiosk.cancel_queue_pass") }}
              </BaseButton>
            </CCol>
          </CRow>
        </template>
      </CRow>
      <Loader
        :is-processing="!activePass || state.isLoading"
        classes="position-absolute"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone"
import useVuelidate from "@vuelidate/core"
import { helpers, required } from "@vuelidate/validators"
import StatusBox from "@/v3components/shared/Alerts/StatusBox.vue"
import Loader from "@/v3components/shared/Loader/Loader.vue"
import Label from "@/v3components/shared/Form/Label.vue"
import InputField from "@/v3components/shared/Form/InputField.vue"
import InfoBox from "@/v3components/shared/Alerts/InfoBox.vue"
import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"
import StudentPassHistory from "@/v3components/Forms/Students/StudentPassHistory.vue"
import { useStore } from "vuex"
import {
  reactive,
  computed,
  onMounted,
  inject,
  watch,
  ref,
  onUnmounted
} from "vue"
import kioskMode from "@/events/kioskMode/index"
import queueUtils from "@/helpers/queueUtils"
import helpersJS from "@/helpers/index"
import dateTimeUtils from "@/helpers/dateTimeUtils"
import { useI18n } from "vue-i18n"

export default {
  name: "KioskActivePass",
  components: {
    Loader,
    StatusBox,
    Label,
    InputField,
    InfoBox,
    BaseButton
  },
  emits: ["cancel"],
  setup(args, { emit }) {
    const store = useStore()
    const { t } = useI18n()

    const modal = inject("modal")

    const isQueuePass = ref(false)

    const state = reactive({
      interval: null,
      isQueuePassInterval: null,
      timeout: 120,
      visible: false,
      passStatuses: {
        waiting: t("kiosk.waiting_approval"),
        approved: t("kiosk.active"),
        expired: t("kiosk.ended"),
        canceled: t("kiosk.canceled")
      },
      actions: {
        approved: 1,
        end: 2,
        arrived: 3,
        returning: 4,
        cancel: 5
      },
      counter: 1,
      teacherPin: "",
      responseMessageTeacherApproval: null,
      responseMessageRoomApproval: null,
      isLoading: false,
      updatePassHistory: true,
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    })

    const validationMessages = {
      required: "kiosk.this_field_is_required"
    }

    const validations = {
      teacherPin: {
        required: helpers.withMessage(validationMessages.required, required)
      }
    }
    const v$ = useVuelidate(validations, state)

    const isValid = computed(() => !v$.value.$invalid)

    const errors = computed(() => {
      const errorObj = {}
      v$.value.$errors.forEach((err) => {
        errorObj[err.$property] = err.$message
      })

      return errorObj
    })

    const activePass = computed(() => store.getters["kiosks/activePass"])
    const passHistories = computed(() => store.getters["kiosks/passHistories"])
    const activeKiosk = computed(() => store.getters["kiosks/activeKiosk"])
    const passLimit = computed(() => store.getters["passes/pass_limit"])

    const isPassApproved = computed(() => {
      return Boolean(activePass?.value?.approved_by)
    })

    const timeInPass = computed(() => {
      return state.counter && activePass.value
        ? helpersJS.secondsToTimeString(
            moment().diff(
              activePass.value.parent && activePass.value.parent.approved_at
                ? moment(activePass.value.parent.approved_at)
                : activePass.value.approved_at
                  ? moment(activePass.value.approved_at)
                  : moment(),
              "seconds"
            )
          )
        : ""
    })

    const currentStatus = computed(() => {
      if (isQueuePass.value) {
        return "queue"
      }
      if (
        activePass.value &&
        activePass.value.pass_status == 1 &&
        activePass.value.approved_at === null &&
        !activePass.value.parent
      ) {
        return "waiting"
      }
      if (
        activePass.value &&
        activePass.value.pass_status == 1 &&
        activePass.value.approved_at === null &&
        activePass.value.parent
      ) {
        return "approved"
      }
      if (
        activePass.value &&
        activePass.value.pass_status == 1 &&
        activePass.value.approved_at !== null &&
        activePass.value.completed_at === null
      ) {
        return "approved"
      }
      return "expired"
    })

    const isCurrentStatusQueue = computed(() => {
      return currentStatus.value === "queue"
    })

    const queuePassTitle = computed(() => {
      if (!isCurrentStatusQueue.value) {
        return ""
      }
      return `${t("kiosk.waiting_in_queue")} : ${activePass?.value?.queue_number || 0}`
    })

    const isLayoverPass = computed(() => {
      return activePass.value &&
        (activePass.value.to_type == "App\\Models\\User" ||
          (activePass.value.to && activePass.value.to.trip_type == "Layover"))
        ? true
        : false
    })

    const timeoutCounter = computed(() => {
      return moment.utc(state.timeout * 1000).format("mm:ss")
    })

    const isAutoPass = computed(() => {
      return (
        activePass.value &&
        activePass.value?.flags &&
        activePass.value?.flags?.auto_pass &&
        activePass.value.flags?.auto_pass?.is_valid
      )
    })

    const timeInputZone = computed(() => {
      if (isCurrentStatusQueue.value) {
        return "UTC"
      }
      return "school"
    })

    const timeInputFormat = computed(() => {
      return isCurrentStatusQueue.value
        ? "YYYY-MM-DD HH:mm:ss"
        : "YYYY-MM-DDTHH:mm:ss.000000Z"
    })

    onMounted(() => {
      initTimeout()
      initSockets()
      state.visible = true
      state.isQueuePassInterval = setInterval(() => {
        isQueuePass.value =
          activePass.value && queueUtils.isPassStatusQueue(activePass.value)
      }, 200)
    })

    onUnmounted(() => {
      if (state.isQueuePassInterval) {
        clearInterval(state.isQueuePassInterval)
      }
    })

    const cancelPass = () => {
      if (window.confirm(t("kiosk.confirm_cancel_pass"))) {
        state.isLoading = true
        resetResponseMessages()
        if (activePass.value) {
          if (isCurrentStatusQueue.value) {
            store
              .dispatch("passes/cancelStudentQueuePass", activePass.value.id)
              .then(() => {
                state.isLoading = false
                setSuccessResponse(
                  t("kiosk.your_queue_pass_has_successfully_been_ended")
                )
                setTimeout(() => {
                  resetResponseMessages()
                  cancel()
                }, 1000)
              })
              .catch((err) => {
                const response = err.response.data
                setErrorResponse(response.message, response.errors)
                state.isLoading = false
              })
          } else {
            const data = {
              id: activePass.value.id,
              data: {
                action: 8,
                kiosk_id: activeKiosk.value.id
              }
            }
            store
              .dispatch("kiosks/updatePass", data)
              .then(() => {
                state.isLoading = false
                setSuccessResponse(
                  t("kiosk.your_pass_has_successfully_been_ended")
                )
                setTimeout(() => {
                  resetResponseMessages()
                  cancel()
                }, 1000)
              })
              .catch((err) => {
                const response = err.response.data
                setErrorResponse(response.message, response.errors)
                state.isLoading = false
              })
          }
        }
      }
    }

    const updatePassStuff = (argAction, returnType) => {
      resetResponseMessages()
      if (isValid.value) {
        state.isLoading = true
        state.updatePassHistory = false
        const elem = {
          id: activePass.value.id,
          data: {
            teacher_pin: state.teacherPin,
            approval_message: state.teacherNote,
            action: argAction,
            kiosk_id: activeKiosk.value.id
          }
        }
        if (returnType) {
          elem.data.return_type = returnType
        }

        store
          .dispatch("kiosks/updatePass", elem)
          .then((res) => {
            store.commit("kiosks/REPLACE_ACTIVE_PASS", res.data.data)
            state.isLoading = false
            setSuccessResponse(
              t("kiosk.your_pass_has_successfully_been_approved")
            )
            setTimeout(() => {
              resetResponseMessages()
              v$.value.$reset()
              // logOutUser();
            }, 1000)
          })
          .catch((err) => {
            if (err && err.response && err.response.status == 401) {
              cancel()
            }
            const response = err.response.data
            setErrorResponse(response.message, response.errors)
            state.isLoading = false
          })
      } else {
        v$.value.$touch()
      }
    }

    const autoApprovePass = () => {
      state.isLoading = true
      const data = {
        passId: activePass.value.id,
        action: 1,
        kiosk_id: activeKiosk.value.id
      }
      store
        .dispatch("kiosks/autoApprovePass", data)
        .then((res) => {
          store.commit("kiosks/REPLACE_ACTIVE_PASS", res.data.data)
          state.isLoading = false
          setSuccessResponse(
            t("kiosk.your_pass_has_successfully_been_approved")
          )
          setTimeout(() => {
            resetResponseMessages()
            cancel()
          }, 1200)
        })
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
            cancel()
          }
          const response = err.response.data
          setErrorResponse(response.message, response.errors)
          state.isLoading = false
        })
    }

    const initTimeout = () => {
      if (!state.interval) {
        state.interval = setInterval(() => {
          if (state.timeout > 0) {
            state.timeout--
          } else {
            clearInterval(state.interval)
            cancel()
          }
        }, 1000)
      }
    }

    const initSockets = () => {
      kioskMode.initKioskPassEvents(activePass.value.user_id)
    }

    const destroySockets = () => {
      kioskMode.destroyKioskPassEvents()
    }

    const cancel = () => {
      destroySockets()
      clearInterval(state.interval)
      emit("cancel")
    }

    const setSuccessResponse = (message) => {
      state.reqResponse = {
        type: "success",
        message: message ? message : t("common.successfully_created"),
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.reqResponse = {
        type: "danger",
        message: message ? message : t("kiosk.something_went_wrong"),
        errors: errors ? errors : {}
      }
    }

    const resetResponseMessages = () => {
      state.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    }

    watch(currentStatus, (newStatus) => {
      if (newStatus === "expired") {
        cancel()
      }
    })

    const showPassHistory = (passHistoryOptions) => {
      modal.open(StudentPassHistory, {
        size: "lg",
        title: t("common.todays_history"),
        props: {
          options: passHistoryOptions
        },
        help: "todays_history"
      })
    }

    return {
      state,
      activePass,
      passHistories,
      activeKiosk,
      passLimit,
      timeInPass,
      currentStatus,
      isCurrentStatusQueue,
      queuePassTitle,
      isLayoverPass,
      timeoutCounter,
      isAutoPass,
      isValid,
      errors,
      dateTimeUtils,
      isPassApproved,
      timeInputZone,
      timeInputFormat,
      cancelPass,
      updatePassStuff,
      autoApprovePass,
      initTimeout,
      initSockets,
      destroySockets,
      cancel,
      showPassHistory
    }
  }
}
</script>
